import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StreamService } from '../../../service/stream.service';
import { FormBuilder } from '@angular/forms';
import { AppdataService } from '../../../service/appdata.service';

@Component({
  selector: 'app-edit-track',
  standalone: false,
  templateUrl: './edit-track.component.html',
  styleUrl: './edit-track.component.scss'
})
export class EditTrackComponent {
  readonly track = inject<any>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<EditTrackComponent>);
  statusOptions: any[] = [];
  categories: any[] = [];
  trackForm: any;
  created: any;
  updated: any;

  constructor(
    private streamService: StreamService,
    private fb: FormBuilder,
    private appData: AppdataService
  ) {
    this.trackForm = this.fb.group({
      name: '',
      description: '',
      categoryId: '',
      status: '',
    });
    this.trackForm.patchValue(this.track);
    this.statusOptions = this.appData.statuses;
    this.created = new Date(this.track.dateCreated).toLocaleString('de-DE');
    this.updated = new Date(this.track.dateUpdated).toLocaleString('de-DE');
    this.appData.categories.subscribe((data) => {
      this.categories = data;
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }

  async saveTrackData() {
    // console.log('Save Track Data', this.trackForm.value);
    // return



    if (this.trackForm.invalid) return;
    let updateResult = await this.streamService.updateTrack(this.track.id, this.trackForm.value.name || null, this.trackForm.value.description || null, this.trackForm.value.categoryId || null, this.trackForm.value.status);
    if (updateResult !== false) this.appData.loadAllTracks();
    this.dialogRef.close(true);
  }
}
